import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {TranslateModule} from '@ngx-translate/core';
import {HomeRoutingModule} from "./home-routing.module";
import {HomeComponent} from "./home.component";
import {HomeService} from "./home.service";
import {CoreModule} from "../../core/core.module";
import {PickupWeekComponent} from "./pickup-week/pickup-week.component";
import {PickupDayComponent} from "./pickup-week/pickup-day/pickup-day.component";
import {ModalCovidComponent} from "./covid-modal/modal-covid.component";

@NgModule({
    imports: [CommonModule, HomeRoutingModule, TranslateModule, CoreModule],
    providers: [HomeService],
    declarations: [
        HomeComponent,
        PickupWeekComponent,
        PickupDayComponent,
        ModalCovidComponent
    ],
    exports:[ModalCovidComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./public/upgrade/feature/home/home.module.ts